import { CSSObject } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const getFooterStyles = (onlySharing: boolean): CSSObject => ({
  alignItems: 'end',
  background:
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);',
  boxSizing: 'border-box',
  display: 'inline-flex',
  height: '70px',
  justifyContent: onlySharing ? 'flex-end' : 'space-between',
  padding: '8px 12px',
  width: '100%',
  zIndex: 1,
})

const sendMessageStyles: CSSObject = {
  height: '44px',
  width: '259px',
  border: `1px solid ${colors.white.base}`,
  borderRadius: '22px',
  boxSizing: 'border-box',
  paddingLeft: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  span: {
    fontSize: fontSizes.xLarge,
    color: colors.white.base,
    marginRight: '20px',
    fontFamily: fonts['helvetica'],
  },
}

const sharingStyles: CSSObject = {
  position: 'relative',
  color: colors.white.base,
  paddingBottom: '10px',
  paddingRight: '6px',
}

const ctaWrapper: CSSObject = {
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  top: '296px',
  width: '375px',
  zIndex: 2,
}

const ctaStyles: CSSObject = {
  backgroundColor: 'rgba(255,255,255,0.3)',
  borderRadius: '22px',
  color: 'white',
  marginTop: '6px',
  padding: '14px',
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.medium,
}

const ctaAndIcon: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  color: 'white',
}

export const styles = {
  ctaAndIcon,
  ctaStyles,
  ctaWrapper,
  getFooterStyles,
  sendMessageStyles,
  sharingStyles,
}
